import { dfs } from './dfs.js';

export { preorder };

function preorder(g, vs) {
  return dfs(g, vs, 'pre');
}
